import React, { FC, PropsWithChildren, createContext, useMemo, useState } from 'react';
import { ToastData, ToastProviderValues } from './types';

const ToastContext = createContext<ToastProviderValues>({
  toasts: [],
} as ToastProviderValues);

const ToastProvider: FC<PropsWithChildren> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastData[]>([]);

  const addToast = (toast: ToastData) => {
    setToasts((prevToasts) => [...prevToasts, { id: Date.now(), ...toast }]);
  };

  const removeToast = (toastId: number) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== toastId));
  };

  const contextValue = useMemo(
    () => ({
      toasts,
      addToast,
      removeToast,
    }),
    [toasts, addToast, removeToast]
  );

  return <ToastContext.Provider value={contextValue}>{children}</ToastContext.Provider>;
};

export { ToastContext, ToastProvider };
